mutation InvoiceSigningAccountingUnStamper($input: InvoiceSigningAccountingUnstamperInput!) {
  invoiceSigningAccountingUnstamper(input: $input) {
    invoice {
      _rowTimestamp
    }
  }
}
